import React from 'react';
import { CheckCircle, Award, Clock, Users } from 'lucide-react';
import { images } from '../data/mock';

const features = [
  {
    icon: Award,
    title: 'Quality Craftsmanship',
    description: 'Every project completed with attention to detail and excellence'
  },
  {
    icon: Clock,
    title: 'Reliable & On Time',
    description: 'Dependable service you can count on, every time'
  },
  {
    icon: Users,
    title: 'Customer Focused',
    description: 'Your satisfaction is our top priority'
  }
];

const About = () => {
  return (
    <section id="about" className="py-20 bg-bg-page">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Column */}
          <div className="relative">
            <div className="relative rounded-[32px] overflow-hidden shadow-2xl">
              <img
                src={images.about}
                alt="Professional landscaping work"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/40 to-transparent" />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 lg:-right-10 bg-white rounded-2xl p-6 shadow-xl max-w-[200px]">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-brand-primary rounded-full flex items-center justify-center">
                  <CheckCircle className="text-brand-dark" size={20} />
                </div>
                <span className="font-bold text-brand-dark text-2xl">100%</span>
              </div>
              <p className="text-text-secondary text-sm font-medium">
                Customer Satisfaction Guaranteed
              </p>
            </div>
          </div>

          {/* Content Column */}
          <div>
            <div className="inline-flex items-center gap-2 bg-brand-primary/10 border border-brand-primary/30 rounded-full px-4 py-2 mb-6">
              <span className="text-brand-dark text-sm font-semibold">
                About Our Company
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-6 leading-tight">
              Your Trusted Partner for
              <span className="text-brand-dark"> Lawn & Landscape</span> Solutions
            </h2>

            <p className="text-text-secondary text-lg leading-relaxed mb-8">
              At TWINS LAWN & LANDSCAPE LLC, we are committed to providing
              professional lawn care and landscaping services that exceed
              expectations. With attention to detail and a passion for creating
              beautiful outdoor spaces, we serve both residential and commercial
              properties with dedication and quality craftsmanship.
            </p>

            <p className="text-text-secondary text-lg leading-relaxed mb-10">
              From routine lawn maintenance to complete landscape transformations,
              hardscapes, and seasonal services, our experienced team delivers
              results you can be proud of.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-3 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="text-center sm:text-left">
                  <div className="w-12 h-12 bg-brand-primary/10 rounded-xl flex items-center justify-center mb-3 mx-auto sm:mx-0">
                    <feature.icon className="text-brand-dark" size={24} />
                  </div>
                  <h3 className="font-semibold text-text-primary mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-text-light text-sm">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
